<template>
  <div
    ref="scrollTable"
    class="pega-scroll-table"
    data-test="scroll-table"
    @scroll="onScroll"
  >
    <table class="boss-table-4">
      <tr>
        <th
          class="border pega-input"
          data-test="all-check"
          @click="checkedMax();"
        >
          <input
            type="checkbox"
            class="boss-input-checkbox"
            :checked="isSelected"
          >
        </th>
        <th>応募日</th>
        <th>応募者</th>
        <th>セミナー</th>
        <th>メッセージ</th>
        <th>ステータス</th>
        <th>備考</th>
      </tr>
      <seminar-entry-outline
        v-for="(entryObject, key) in infinityEntryObjects"
        :key="key"
        :display-target="displayTarget"
        :entry-object="entryObject"
        @update-checked="updateChecked"
      />
    </table>
    <infinite-loading
      ref="infiniteLoading"
      @infinite="infiniteHandler"
    >
      <div
        slot="no-more"
        data-test="infinite-loading-no-more"
      >
        全{{ renderingEntryObjects.length }}名
      </div>
      <div slot="no-results">
        応募者がいません。
      </div>
      <div slot="spinner" />
    </infinite-loading>
    <selected-counter :checked-count="checkedCount" />
  </div>
</template>

<style scoped>
table, tr, th {
  height: 100%;
}
th > div {
  height: 100%;
  width: 100%;
}
</style>
<script>
import SeminarEntryOutline from '@/components/molecules/SeminarEntryOutline'
import SelectedCounter from '@/components/molecules/SelectedCounter'
import _ from 'lodash'
import InfiniteLoading from 'vue-infinite-loading'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import { hideAllPoppers } from 'floating-vue'

export default {
  components: {
    SeminarEntryOutline,
    SelectedCounter,
    InfiniteLoading
  },
  props: {
    entryObjects: {
      type: Array,
      required: true
    },
    displayTarget: {
      type: Array,
      default: () => []
    },
    selectLimit: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      isSelected: false,
      infinityEntryObjects: [],
      pastScrollTop: 0
    }
  },
  computed: {
    renderingEntryObjects () {
      return _(this.entryObjects)
        .filter('isShow')
        .filter('isDisplayTarget')
        .value()
    },
    checkedCount () {
      return _(this.renderingEntryObjects).filter('isChecked').value().length
    }
  },
  watch: {
    renderingEntryObjects (val) {
      if (_.has(this.$refs, 'infiniteLoading.stateChanger')) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.$set(this, 'isSelected', false)
      this.infinityEntryObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(val, 50)
    }
  },
  methods: {
    checkedMax () {
      this.$set(this, 'isSelected', !this.isSelected)
      if (this.isSelected && this.renderingEntryObjects.length > this.selectLimit) {
        // 上から、selectLimitの件数だけ選択する
        // 実際、全件選択されていないが、利用確率が低いため、all-checkのチェックボックスはtrueでOK
        this.renderingEntryObjects.slice(0, this.selectLimit).forEach((memberObject) => {
          memberObject.isChecked = this.isSelected
        })
        this.$toasted.global.successRightTopSingleton({ message: `一括で処理できる最大数（${this.selectLimit}名）を選択しました。` })
      } else {
        // 全件操作する
        _.forEach(this.renderingEntryObjects, o => { o.isChecked = this.isSelected })
      }
    },
    updateChecked (data) {
      const index = this.renderingEntryObjects.findIndex(entryObject => entryObject.entry.id === data.id)
      this.$set(this.renderingEntryObjects[index], 'isChecked', data.isChecked)
    },
    onScroll () {
      this.$set(this, 'pastScrollTop', this.$refs.scrollTable.scrollTop)
      hideAllPoppers()
    },
    scrollTo (top) {
      this.$refs.scrollTable.scrollTo({ top })
    },
    infiniteHandler ($state) {
      if (this.infinityScrollIterator) {
        const next = this.infinityScrollIterator.next()
        if (next.done) {
          $state.complete()
        } else {
          this.infinityEntryObjects.push(...next.value)
          if (this.pastScrollTop > this.$refs.scrollTable.scrollTop) {
            this.$nextTick(() => {
              this.scrollTo(this.pastScrollTop)
            })
          }
          $state.loaded()
        }
      }
    }
  }
}
</script>
